import React from 'react';
import { Link } from 'react-router-dom';
import { I18n } from "aws-amplify";
import { Card, Table, Spinner } from 'react-bootstrap';
import { parseAsMoment } from './../../../shared/utils/date'

const NewUsersCard = ({ loading, users, totalCount , limit = 10}) => {

  const list = (users || []).slice(0, limit);

  // ユーザ詳細ページへのリンク情報
  const goUserPage = (argUserId) => ({
    pathname: `/user/${argUserId}`
  });
  
  const headerText = totalCount
    ? `新規ユーザ（期間内／合計 ${totalCount} 件・最新${limit}件）`
    : `新規ユーザ（期間内／最新 ${limit} 件）`;

  return (
    <Card>
      <Card.Header>{headerText}</Card.Header>
      <Card.Body className="p-2">
        <Table size="sm" hover responsive className="text-nowrap">
          <thead>
            <tr>
              <th>ユーザ名</th>
              <th>作成日</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td colSpan={2} className="text-center">
                  <div className="text-center py-3">
                    <Spinner
                      as="span"
                      animation="border"
                      role="status"
                      aria-hidden="true"
                    />
                  </div>
                </td>
              </tr>
            ) : list.length === 0 ? (
              <tr>
                <td colSpan={2} className="text-center text-muted">
                  データがありません
                </td>
              </tr>
            ) : (
              list.map((u) => (
                <tr key={u.id}>
                  <td>
                    <Link 
                      to={goUserPage(u.id)}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                      {u.username}
                    </Link>{' '}
                  </td>
                  <td>
                    {u.createdAt
                      ? parseAsMoment(u.createdAt).format('YYYY年MM月DD日 HH:mm')
                      : ''}
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </Table>
      </Card.Body>
    </Card>
  );
};

export default NewUsersCard;
